import React, { useEffect, useState } from 'react'
import lpllogo from '../../assets/images/logo.png';
import suburbunlogo from '../../assets/images/suburban.webp';
import '../../assets/stylesheet/layout.scss';
import '../../assets/stylesheet/feedback.scss';
import 'font-awesome/css/font-awesome.min.css';
import GetUserData from '../../utilities/getUserDetails';

function Thanks() {
    const [userInfo, setUserInfo] = useState(GetUserData());
    const isSuburban = userInfo?.Company?.toLowerCase() === "sdpl";
  return (
    <>
        <div className='container-fluid feedback-form'>
            <div className='row'>
            <div className='col-14 col-sm-14 col-md-9 col-lg-9 col-xl-9 '>
            <div className='logo-section'>
                        {/* <img alt="Dr Lal Path Labs" className='f-logo' src={lpllogo}/> */}
                    </div>                   
                </div>
                <div className='col-14 col-sm-14 col-md-8 col-lg-8 col-xl-8'>
                    <div className='lang-section'>
                        <div className='text-center'>
                            <div className='text-center mb-4'>
                                 {isSuburban ? (
                                        <img alt="Suburban Diagnostics India Pvt Limited" style={{ maxheight: '200px', maxWidth: '200px' }} className='f-logo' src={suburbunlogo} />
                                    ) : (
                                        <img alt="Dr Lal Path Labs" style={{ maxheight: '200px', maxWidth: '200px' }} className='f-logo' src={lpllogo} />
                                    )}
                                {/* <img style={{maxheight: '200px', maxWidth: '200px'}} alt="Thanks for your feedback" src={lpllogo}/> */}
                            </div>
                            <div className='Page-title mb-5 text-center'><h3>Thank you for your Valuable Feedback.</h3></div>
                           
                        </div>
                       
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}
export default Thanks;
